import { useEffect, useState } from 'react'
import { type_GM_STATE } from '../../helpers'
import { useWishlistStore } from '../helpers/list-store'
import { openModal } from '../helpers/useModal'
import { HeartIcon } from '../icons/HeartIcon'
import { wishlistProviderService } from '../helpers/provider.service'

declare var GM_STATE: type_GM_STATE
declare var theme: { pageType: string }

const MOBILE_HEADER_BREAKPOINT: number = 1024

export function AccountHeader() {
  const wishlistStore = useWishlistStore()
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_HEADER_BREAKPOINT)

  const handleClick = async () => {
    const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash
    const wishlistPagePath = '/account?view=wishlist'
    const loggedIn = await wishlistProviderService.isLoggedIn()

    if (loggedIn) {
      window.location.href = rootUrlWithoutSlash + wishlistPagePath
    } else {
      if (theme.pageType.includes('customers')) {
        const formSelectors = document.querySelectorAll<HTMLFormElement>('.js-form-account-custom')
        if (!formSelectors.length) {
          return
        }
        formSelectors.forEach(form => {
          const inputReturn = form.querySelector<HTMLInputElement>('input[name="return_to"]')
          if (inputReturn) {
            inputReturn.value = rootUrlWithoutSlash + wishlistPagePath
          } else {
            form.insertAdjacentHTML(
              'beforeend',
              `<input type="hidden" name="return_to" value="${rootUrlWithoutSlash}${wishlistPagePath}">`
            )
          }
        })
      } else {
        sessionStorage.setItem('returnTo', wishlistPagePath)
        openModal('account-slideout')
      }
    }
  }

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_HEADER_BREAKPOINT - 1}px)`)

    const syncIsMobile = (event?: MediaQueryListEvent) => {
      setIsMobile(event ? event.matches : mediaQuery.matches)
    }

    syncIsMobile()
    mediaQuery.addEventListener('change', syncIsMobile)

    return () => {
      mediaQuery.removeEventListener('change', syncIsMobile)
    }
  }, [])

  return (
    <div className='mega-menu__wishlist' tabIndex={0} onClick={handleClick}>
      {isMobile ? (
        <HeartIcon className={`Icon ${wishlistStore.hasAnyItems ? 'Icon__WishList' : ''}`} />
      ) : (
        'Wishlist'
      )}
      {!isMobile && <div className={`mega-menu__dot js-wishlist-dot${!wishlistStore.hasAnyItems ? ' hidden' : ''}`}></div>}
    </div>
  )
}
